<template>
  <div
    class="relative overflow-hidden"
    :class="{
      'w-12 h-12 rounded-lg': size === 'xs',
      'w-14 h-14 rounded-md': size === 'sm',
      'w-[86px] h-[86px] rounded-xl': size === 'md',
      'rounded-lg': size === 'base',
      'w-24 h-24 sm:w-40 sm:h-40 rounded-lg': size === 'lg',
    }"
  >
    <Media
      v-if="src"
      :src="src"
      :type="hasThumbnail && isVideo ? 'image/png' : type"
      :name="item.name"
      preview
      @loaded="$emit('loaded')"
    />
    <div v-else class="flex items-center justify-center">
      <FileFive
        :class="{
          'w-5 h-5': size === 'xs',
          'w-8 h-8': size === 'sm',
          'w-9 h-9': size === 'md',
          'w-10 h-10': size === 'base',
          'w-12 h-12': size === 'lg',
        }"
      />
    </div>
    <VideoRecorder
      v-if="isVideo"
      class="absolute rounded-full text-white bg-gray-300 bg-opacity-40"
      :class="{
        'w-2 h-2 top-0.5 left-0.5 p-px': size === 'xs',
        'w-4 h-4 top-0.5 left-0.5 p-0.5': size === 'sm',
        'w-5 h-5 top-1 left-1 p-1': size === 'md',
        'w-6 h-6 top-1 left-1 p-1': size === 'base',
        'w-8 h-8 top-1.5 left-1.5 p-1.5': size === 'lg',
      }"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import Media from "@/Tailwind/Components/Media.vue";
import FileFive from "@/Tailwind/Icon/FileFive.vue";
import { VideoRecorder } from "@/Icons";

defineEmits(["loaded"]);

const props = defineProps({
  item: { type: Object, required: true },
  size: {
    type: String,
    validator: (val) => ["xs", "sm", "md", "base", "lg"].includes(val),
    default: "base",
  },
});

const hasThumbnail = computed(() => !!props.item.thumbnail_url);

const src = computed(() =>
  hasThumbnail.value
    ? props.item.thumbnail_url
    : [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "video/mp4",
        "video/quicktime",
        "video/ogg",
        "video/webm",
      ].includes(type.value)
    ? URL.createObjectURL(props.item.data ? props.item.data : props.item)
    : null
);

const type = computed(() => props.item.type || props.item.mime_type);

const isVideo = computed(() => type.value?.includes("video"));
</script>
